var map = {
	"./360_image.png": 353,
	"./Banat_IT_Logo.svg": 3166,
	"./calendar.svg": 2515,
	"./communities/BudapestJS_logo@2x.png": 3323,
	"./communities/JSLeague_logo.svg": 521,
	"./communities/JSgirls_logo.svg": 863,
	"./communities/OradeaTechHub_logo@2x.png": 5896,
	"./communities/ReactGraphQL-Academy_logo@2x.png": 8071,
	"./communities/bucharestJS_logo.svg": 6714,
	"./communities/frontend_bp_logo.svg": 7803,
	"./communities/frontend_hub_logo.svg": 7174,
	"./communities/hackages_logo@2x.png": 9637,
	"./communities/iasiJS_logo.svg": 3609,
	"./communities/jsconf_bp_logo.svg": 9999,
	"./communities/jsheroes_logo.svg": 8394,
	"./communities/ktz_logo.svg": 2649,
	"./communities/madridJS@2x.png": 5505,
	"./communities/ngBucharest_logo@2x.png": 8672,
	"./communities/ngparty_no-spray_logo.svg": 1208,
	"./communities/oth_logo.svg": 6686,
	"./communities/pionir_logo.svg": 4091,
	"./communities/tdt_logo.svg": 2483,
	"./communities/tech_hub_logo.svg": 2022,
	"./communities/vueJSbarcelona_logo.svg": 4611,
	"./facebook.svg": 4348,
	"./icon.png": 2387,
	"./instagram.svg": 569,
	"./invitations/aki-rose-braun.jpg": 8270,
	"./invitations/anders-heijlsberg.jpg": 2196,
	"./invitations/andre-staltz.jpg": 1301,
	"./invitations/angie-jones.jpg": 7675,
	"./invitations/asim-hussain.jpg": 3746,
	"./invitations/ben-lesh.jpg": 3040,
	"./invitations/benedikt-meurer.jpg": 1027,
	"./invitations/brian-clark.jpg": 4666,
	"./invitations/brian-terlson.jpg": 5096,
	"./invitations/brian-vaughn.jpg": 3997,
	"./invitations/charlie-gerard.jpg": 796,
	"./invitations/christoph-nakazawa.jpg": 9802,
	"./invitations/dan-abramov.jpg": 4765,
	"./invitations/daniel-ehrenberg.jpg": 1124,
	"./invitations/douglas-crockford.jpg": 4238,
	"./invitations/eduardo-san-martin-morote.jpg": 3226,
	"./invitations/elisabeth-engel.jpg": 4418,
	"./invitations/emma-bostian.jpg": 5902,
	"./invitations/evan-you.jpg": 4905,
	"./invitations/franziska-hinkelmann.jpg": 6820,
	"./invitations/isabella-silveira-de-souza.jpg": 2543,
	"./invitations/jake-archibald.jpg": 9887,
	"./invitations/jay-phelps.jpeg": 2979,
	"./invitations/jordan-harband.jpg": 3388,
	"./invitations/kara-erickson.jpg": 1423,
	"./invitations/kenneth-rohde-christiansen.jpg": 8553,
	"./invitations/kent-c-dodds.jpg": 1967,
	"./invitations/lea-verou.jpg": 5074,
	"./invitations/leonie-watson.jpg": 1153,
	"./invitations/martin-splitt.jpg": 4297,
	"./invitations/michael-jackson.jpg": 5607,
	"./invitations/mike-grabowsky.jpg": 4539,
	"./invitations/minko-gechev.jpg": 3690,
	"./invitations/myles-borins.jpg": 462,
	"./invitations/nicole-sullivan.jpg": 7888,
	"./invitations/orta-therox.jpg": 8991,
	"./invitations/peter-marshall.jpg": 1875,
	"./invitations/sara-soueidan.jpg": 7013,
	"./invitations/shai-reznik.jpg": 7828,
	"./invitations/shmuela-jacobs.jpg": 6837,
	"./invitations/srushtika-neelakantam.jpg": 9290,
	"./invitations/stanimira-vlaeva.jpg": 70,
	"./invitations/suz-hinton.jpg": 4683,
	"./invitations/trent-willis.jpg": 6840,
	"./linkedin.svg": 7067,
	"./logo-revojs.svg": 7719,
	"./partners/Auth0_logo.svg": 645,
	"./partners/DevPlant_logo.svg": 5400,
	"./partners/TechEvents_logo@2x.png": 4236,
	"./partners/TimisoaraTech_logo@2x.png": 8364,
	"./partners/bereta_logo.svg": 5196,
	"./partners/craftwand_logo.svg": 5629,
	"./partners/ctrl-D_logo.svg": 7229,
	"./partners/ds-smith_logo.svg": 9320,
	"./partners/glorium_logo.svg": 3290,
	"./partners/irian_logo.svg": 3146,
	"./partners/microsoft_logo.svg": 3719,
	"./partners/progress_logo.svg": 9581,
	"./partners/vrh_logo.svg": 5086,
	"./partners/zdd_podcast_logo.svg": 9095,
	"./photos/img-afterparty-2019.png": 2155,
	"./photos/img-afterparty-2023.png": 715,
	"./photos/img-conference-2019.png": 4319,
	"./photos/img-conference-2023.png": 1728,
	"./photos/img-workshop-2019.png": 5569,
	"./press/01.logo.svg": 5131,
	"./press/02.symbol.svg": 8496,
	"./press/03.logo_diagram.svg": 6605,
	"./press/04.symbol_diagram.svg": 4096,
	"./press/05.color_story.svg": 6239,
	"./press/06.logo_dark-grey-bg.svg": 4743,
	"./press/07.logo_white-bg.svg": 9437,
	"./press/08.logo_orange-bg.svg": 9392,
	"./press/09.logo_monochrome_black-bg.svg": 598,
	"./press/10.logo_monochrome_white-bg.svg": 2478,
	"./revo.js.svg": 6790,
	"./revojs_where-to.png": 9836,
	"./speakers/alex_bw.jpg": 4167,
	"./speakers/alex_moldovan.jpg": 7723,
	"./speakers/anna_bw.jpg": 3322,
	"./speakers/atila_bw.jpg": 6148,
	"./speakers/ben_bw.jpeg": 3666,
	"./speakers/benedek_bw.jpg": 1321,
	"./speakers/benedek_gagyi.jpg": 8786,
	"./speakers/boyan_mihaylov.jpg": 2394,
	"./speakers/ciprian_bw.jpg": 2283,
	"./speakers/csaba_patkos.png": 5216,
	"./speakers/diana_bw.jpeg": 7116,
	"./speakers/diana_macau.jpg": 9543,
	"./speakers/dominic_elm.jpg": 3597,
	"./speakers/erik_bw.jpg": 4115,
	"./speakers/gleb_bahmutov.jpg": 8729,
	"./speakers/jay_bw.jpg": 8997,
	"./speakers/jennifer_wadella.jpg": 7346,
	"./speakers/josh_bw.jpg": 5233,
	"./speakers/katie_koschland.jpg": 1532,
	"./speakers/kenigbolo_meya_stephen.jpg": 9449,
	"./speakers/kenneth_auchenberg.jpg": 9706,
	"./speakers/kenneth_bw.jpeg": 5820,
	"./speakers/kwinten_pisman.jpg": 6166,
	"./speakers/leonie_bw.jpeg": 7946,
	"./speakers/martin_bw.png": 2986,
	"./speakers/martin_hochel.jpg": 1536,
	"./speakers/mathieu_henri.png": 5325,
	"./speakers/matt_bw.png": 9209,
	"./speakers/rachel_bw.jpeg": 3963,
	"./speakers/raluca_nicola.jpg": 3784,
	"./speakers/ritvi_bw.jpg": 1410,
	"./speakers/ruben_restrepo.png": 310,
	"./speakers/sebastian_witalec.png": 8990,
	"./speakers/titian_cernicova_dragomir.png": 8305,
	"./speakers/trent_bw.jpeg": 8190,
	"./sponsors/2023/aci_logo.svg": 1692,
	"./sponsors/2023/bioclinica_logo.svg": 6716,
	"./sponsors/2023/bosch_logo.svg": 4451,
	"./sponsors/2023/cobalt-sign_logo.svg": 2265,
	"./sponsors/2023/cognizant_logo.svg": 2943,
	"./sponsors/2023/doctari-group_logo.svg": 7666,
	"./sponsors/2023/dream_production_logo.svg": 4718,
	"./sponsors/2023/e-spres-oh_logo.svg": 4116,
	"./sponsors/2023/haufe_logo.svg": 7078,
	"./sponsors/2023/interact_logo.svg": 3163,
	"./sponsors/2023/metro_logo.svg": 8916,
	"./sponsors/2023/opswat_logo.svg": 7816,
	"./sponsors/2023/quarticle_logo.svg": 4993,
	"./sponsors/2023/smilecloud_logo.svg": 2807,
	"./sponsors/2023/syneto_logo.svg": 7430,
	"./sponsors/2023/unifiedpost_logo.svg": 5945,
	"./sponsors/2023/visma_logo.svg": 7469,
	"./sponsors/2023/vsp_logo.svg": 6396,
	"./sponsors/2023/webamboos_logo.svg": 6801,
	"./sponsors/2023/wevideo_logo.svg": 1621,
	"./sponsors/3pg_logo.svg": 5761,
	"./sponsors/Cognizant_Softvision_logo.svg": 2246,
	"./sponsors/IBM_logo.svg": 3693,
	"./sponsors/busy_machines_logo.svg": 3957,
	"./sponsors/dream_production_logo.svg": 1122,
	"./sponsors/e-spres-oh_logo.svg": 4461,
	"./sponsors/endava_logo.svg": 131,
	"./sponsors/haufe_logo.svg": 1799,
	"./sponsors/imobiliare_logo.svg": 5614,
	"./sponsors/ness_logo.svg": 350,
	"./sponsors/plentymarkets_logo.svg": 8497,
	"./sponsors/steadforce_white_logo.svg": 407,
	"./sponsors/syneto_logo.svg": 5997,
	"./sponsors/unifiedpost_logo.svg": 2093,
	"./sponsors/visma_logo.svg": 525,
	"./sponsors/wevideo_logo.svg": 6209,
	"./talks-2023/apis-requiem.png": 7750,
	"./talks-2023/async-debugging.png": 3631,
	"./talks-2023/css-features.png": 4131,
	"./talks-2023/ethical-choice.png": 6773,
	"./talks-2023/generative-art.png": 6951,
	"./talks-2023/no-bs-seo.png": 1974,
	"./talks-2023/no-generic.png": 2335,
	"./talks-2023/node-testing.png": 6407,
	"./talks-2023/not-linting-enough.png": 1279,
	"./talks-2023/performance-tooling.png": 5471,
	"./talks-2023/rendering-patterns.png": 6426,
	"./talks-2023/security-by-design.png": 747,
	"./talks-2023/testing-strategy.png": 876,
	"./talks-2023/tug-of-war.png": 6454,
	"./talks-2023/type-safe-css.png": 7908,
	"./talks-2023/web-beyond-today.png": 3822,
	"./talks/2019_01.png": 9648,
	"./talks/2019_02.png": 7654,
	"./talks/2019_03.png": 814,
	"./talks/2019_04.png": 1286,
	"./talks/2019_05.png": 7954,
	"./talks/2019_06.png": 1952,
	"./talks/2019_07.png": 2024,
	"./talks/2019_08.png": 3096,
	"./talks/2019_09.png": 1855,
	"./talks/2019_10.png": 5266,
	"./talks/2019_11.png": 975,
	"./talks/2019_12.png": 238,
	"./talks/2019_13.png": 1925,
	"./talks/2019_14.png": 2349,
	"./talks/2019_15.png": 248,
	"./talks/2019_16.png": 7885,
	"./team/01_V1@2x.png": 9466,
	"./team/02_V1@2x.png": 1638,
	"./team/03_V1@2x.png": 6988,
	"./team/04_V1@2x.png": 1751,
	"./team/05_V1@2x.png": 6490,
	"./team/06_V1@2x.png": 7725,
	"./team/07_V1@2x.png": 4884,
	"./team/08_V1@2x.png": 9510,
	"./team/09_V1@2x.png": 7804,
	"./team/10_V1@2x.png": 681,
	"./team/11_V1@2x.png": 7443,
	"./team/12_V1@2x.png": 5517,
	"./team/13_V1@2x.png": 8515,
	"./team/Anca_V1@2x.png": 9245,
	"./team/Dana_V1@2x.png": 5953,
	"./team/Iulia_V1@2x.png": 918,
	"./team/Lia_V1@2x.png": 7511,
	"./team/v2_adrian_bw.jpg": 6974,
	"./team/v2_amalia_bw.jpg": 1818,
	"./team/v2_anca_bw.jpg": 6101,
	"./team/v2_andrea_bw.jpg": 7244,
	"./team/v2_andrei_bw.jpg": 5699,
	"./team/v2_dana_bw.jpg": 1121,
	"./team/v2_horia_bw.jpg": 6275,
	"./team/v2_ilona_bw.jpg": 4329,
	"./team/v2_ion_bw.jpg": 9149,
	"./team/v2_lia_bw.jpg": 931,
	"./team/v2_lucian_bw.jpg": 1245,
	"./team/v2_ovidiu_bw.jpg": 8069,
	"./tim.js-logo.svg": 8862,
	"./twitter.svg": 8794,
	"./venue_location@2x.png": 5961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;